import React, { useEffect, useState } from "react";
import BreadCrumsHeader from "../../common/BreadCrums";
import "../../Fundraiser/FundsDeposited/fundsDeposited.scss";
import SearchBar from "../../common/SearchBar";
import { useDispatch, useSelector } from "react-redux";
// import { getFundsDeposited } from "../../../services/fundraiserService";
import Loader from "../../common/Loader";
import debounce from "lodash.debounce"; // Ensure lodash.debounce is installed
import Box from "../../common/Dashboard/Box";
import PendingTimerIcon from "../../../Assets/Icons/pendingTimer.svg";
import FundsIcon from "../../../Assets/Icons/FundsIcon.svg";
// import AssetsIcon from "../../../Assets/Icons/BankIcon.svg";
import WithdrawalsDataTable from "./Withdrawals";
import FundsDepositedTable from "./FundsDeposited";
import Frequency from "../../common/Dashboard/Frequency";
import { getTransactions } from "../../../services/adminService";

const TotalIncomePage = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.adminReducer?.loading);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [count, setCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedFrequency, setSelectedFrequency] = useState("Yearly");
  const [cards, setCards] = useState({});

  const handleSelect = (index) => {
    setSelectedIndex(index);
  };

  const getTransactionsData = async (timePeriod) => {
    const transactionsPromise = await dispatch(
      getTransactions(timePeriod?.toLowerCase())
    )?.unwrap();
    if (transactionsPromise?.success === true) {
      setCards(transactionsPromise?.cards);
    }
  };

  useEffect(() => {
    let timePeriod = "year";
    switch (selectedFrequency) {
      case "Today":
        timePeriod = "today"; // backend expects 'today'
        break;
      case "Weekly":
        timePeriod = "week";
        break;
      case "Monthly":
        timePeriod = "month";
        break;
      case "Yearly":
        timePeriod = "year";
        break;
      default:
        timePeriod = "year";
        break;
    }
    getTransactionsData(timePeriod);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFrequency])

  const debouncedSearch = React.useMemo(
    () =>
      debounce((query) => {
        // getFundsData(query);
      }, 300), // 300ms debounce time
    []
  );

  const handleSearchChange = (value) => {
    setSearchQuery(value);
    debouncedSearch(value);
  };

  // const handlePageChange = (newPage) => {
  //   setCurrentPage(newPage);
  // };

  // useEffect(() => {
  //   getFundsData(searchQuery);
  // }, [currentPage]);

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const incomeBoxes = [
    {
      text: "Total Income",
      number: `$${cards?.totalIncome ? (cards?.totalIncome / 100).toFixed(2) : 0}`,
      icon: FundsIcon,
    },
    {
      text: "Funds to be Paid",
      number: `$${cards?.pendingFunds ? (cards?.pendingFunds / 100).toFixed(2) : 0}`,
      icon: PendingTimerIcon,
    },
  ];

  const data = [
    {
      text: "Credit",
    },
    {
      text: "Debit",
    },
  ];

  const frequencies = [
    "Today",
    "Weekly",
    "Monthly",
    "Yearly",
  ];

  return (
    <>
      {loading === true && <Loader />}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center col-span-12">
        <BreadCrumsHeader heading="Total Income" items={[]} form={true} />
        <Frequency
          selectedFrequency={selectedFrequency}
          setSelectedFrequency={setSelectedFrequency}
          frequencies={frequencies}
          className="frequency sm:mt-3 sm:w-[50%] md:w-[50%] lg:w-[40%] xl:w-[30%] xl:mt-0 py-2 px-[1%]"
        />
      </div>
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 w-full gap-3 my-[2%]">
        {incomeBoxes?.map((b) => (
          <Box
            text={b?.text}
            number={b?.number}
            icon={b?.icon}
            mainClassName="box p-3 h-[113px]"
            textClassName="text-[14px] font-poppins font-[600] text-[white]"
            numberClassName="text-[36px] font-[700] text-[white] font-montserrat"
            reverse={true}
          />
        ))}
      </div>
      <div className="flex flex-col sm:flex-row justify-start items-start sm:items-center gap-3 sm:gap-4 w-full">
        <SearchBar
          parentDivClass="w-full sm:w-[60%] md:w-[50%] lg:w-[33%]"
          divClassName="relative w-full"
          inputClassName="searchBar md:!h-[46px] p-3 pr-10 w-full text-[14px] font-poppins font-[400] outline-none rounded-[5px] border border-[#D9D9D9] focus:border-[#00ADEF]"
          iconClassName="absolute right-[10px] top-1/2 -translate-y-1/2 w-[18px] h-[18px]"
          placeholder="Search"
          value={searchQuery}
          handleChange={(e) => handleSearchChange(e.target.value)}
        />
        <div className="w-full sm:w-auto sm:flex-1 lg:w-[67%] max-w-md flex justify-center items-center">
          <div className="w-full h-[40px] md:h-[46px] grid grid-cols-2 rounded-[6px] border border-[#00ADEF] p-1">
            {data.map((item, index) => (
              <div
                key={index}
                className={`rounded-[6px] flex justify-center items-center cursor-pointer transition-colors duration-200 ${selectedIndex === index ? "bg-[#00ADEF]" : "bg-white"
                  }`}
                onClick={() => handleSelect(index)}
              >
                <p
                  className={`font-sans text-center font-medium text-sm md:text-base ${selectedIndex === index ? "text-white" : "text-[#8C8C8C]"
                    }`}
                >
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {selectedIndex === 1 ? (
        <FundsDepositedTable key={selectedFrequency} searchQuery={searchQuery} />
      ) : (
        <WithdrawalsDataTable key={selectedFrequency} searchQuery={searchQuery} />
      )}
    </>
  );
};

export default TotalIncomePage;
